/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WarehouseOpsDisposeDdtDtoCreate } from '../../models/warehouse-ops-dispose-ddt-dto-create';

export interface WarehouseControllerCreateDisposeDdt$Params {
      body: WarehouseOpsDisposeDdtDtoCreate
}

export function warehouseControllerCreateDisposeDdt(http: HttpClient, rootUrl: string, params: WarehouseControllerCreateDisposeDdt$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerCreateDisposeDdt.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

warehouseControllerCreateDisposeDdt.PATH = '/warehouse/dispose-ddt';
